import { send } from 'server';

export const getFavoriteGames = () => send({
    ID: 31103,
    requestedFavorites: ['games'],
    description: 'Get Player Favorites Games',
    responses: [31104, 31105]
});

export const changeFavorite = ({ code, isFavorite }) => send({
    ID: 31106,
    requestType: isFavorite ? 'add' : 'remove',
    description: 'Change Player Favorites Games',
    gameTypes: [code],
    responses: [31107, 31108]
});
